// extracted by css-extract-rspack-plugin
export default {"logoContainer":"FlexSuiteTestimonialBanner-module__logoContainer__osTNQ","logoDivider":"FlexSuiteTestimonialBanner-module__logoDivider__PcLNg"};